import { BrowserRouter } from 'react-router-dom';
import { App } from './pages/App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ThemeProvider } from '@mui/system';
import { useEffect, useMemo, useState } from 'react';
import { $mainThemeMode, getMainTheme } from '@brickken/dapp-theme';
import { CssBaseline, PaletteMode } from '@mui/material';
import { configureTranslations } from './helpers/i18nUtils';
import { ColorModeProvider } from './theme/ColorModeContext';
export interface IRootProps {
  name?: string;
  baseAppRoute?: string;
}
configureTranslations();
export const Root = ({ name, baseAppRoute }: IRootProps) => {
  const lang = window.location.href.split('/')[3];
  const [mode, setMode] = useState<'light' | 'dark'>($mainThemeMode.value);
  const basenameWithLang = `${lang}${baseAppRoute}`;

  useEffect(() => {
    const subscriptions = $mainThemeMode.subscribe((mainMode: PaletteMode) => {
      setMode(mainMode);
    });
    return () => subscriptions.unsubscribe();
  }, []);
  const theme = useMemo(() => {
    const modeValid = mode ? mode : 'dark';
    return getMainTheme(modeValid);
  }, [mode]);
  return (
    <Provider store={store}>
      <BrowserRouter basename={basenameWithLang}>
        <ThemeProvider theme={theme}>
          <ColorModeProvider>
            <CssBaseline />
            <App />
          </ColorModeProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  );
};
